import { WorkflowService } from './workflow.service';

export abstract class GenericManagerUserService extends WorkflowService {
  assignToAppraisal(appraisalIds: number[], id: number) {
    const body = { appraisalIds, id };
    return this.put<typeof body, void>('AssignToAppraisal', body);
  }
}
